import { CommonModule } from "@angular/common"
import { Component, inject } from "@angular/core"
import { MatBadgeModule } from "@angular/material/badge"
import { MatButtonModule } from "@angular/material/button"
import { MatDialog } from "@angular/material/dialog"
import { MatIconModule } from "@angular/material/icon"
import { MatListModule } from "@angular/material/list"
import { MatMenuModule } from "@angular/material/menu"
import { AssetDetailComponent } from "../../../assets/asset-detail/asset-detail.component"
import { Transaction } from "../../models/transaction.model"
import { NotificationService } from "../../services"

@Component({
  selector: "app-notification-center",
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatMenuModule,
    MatListModule,
  ],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      [attr.aria-label]="'Notifications (' + count() + ' unread)'"
    >
      <mat-icon
        [matBadge]="count()"
        [matBadgeHidden]="count() === 0"
        matBadgeColor="warn"
        aria-hidden="false"
        class="text-[var(--mat-sys-on-surface-variant)]"
      >
        notifications
      </mat-icon>
    </button>

    <mat-menu #menu="matMenu" class="w-80">
      <div class="px-4 py-2 border-b border-[var(--mat-sys-outline-variant)] flex justify-between items-center">
        <span class="font-semibold text-sm">Notifications</span>
      </div>

      <div *ngIf="count() === 0" class="p-4 text-center text-[var(--mat-sys-on-surface-variant)] text-sm">
        No new notifications
      </div>

      <ng-container *ngIf="count() > 0">
        <div class="px-4 py-2 bg-[var(--mat-sys-primary-container)] text-[var(--mat-sys-on-primary-container)] text-xs font-medium">
          Potential Assets Found ({{ count() }})
        </div>

        <button mat-menu-item *ngFor="let txn of assets()" (click)="reviewAsset(txn)">
          <mat-icon class="text-[var(--mat-sys-primary)]">inventory_2</mat-icon>
          <div class="flex flex-col gap-0.5 leading-tight py-2">
            <span class="text-sm font-medium truncate max-w-[200px]">{{
              txn.remoteName || txn.purposeText
            }}</span>
            <span class="text-xs text-[var(--mat-sys-on-surface-variant)]">
              >{{ txn.amount | currency: "EUR" }} • {{ txn.bookingDate | date: "shortDate" }}</span
            >
          </div>
        </button>
      </ng-container>
    </mat-menu>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class NotificationCenterComponent {
  private notificationService = inject(NotificationService)
  private dialog = inject(MatDialog)

  assets = this.notificationService.potentialAssets
  count = this.notificationService.potentialAssetCount

  reviewAsset(transaction: Transaction) {
    this.dialog.open(AssetDetailComponent, {
      width: "800px",
      data: { transaction },
    })
  }
}
